import { TranslationCatalog } from './translations.types';

export const AUTH_LOGIN_TRANSLATIONS: TranslationCatalog = {
  es: {
    'login.title': 'Inicio de sesión',
    'login.subtitle': 'Ingresa de forma fácil y segura a nuestra plataforma',
    'login.field.email': 'Correo electrónico',
    'login.field.password': 'Contraseña',
    'login.cta': 'Iniciar sesión',
    'login.ctaLoading': 'Ingresando...',
    'login.recoverLead': '¿Olvidaste tu contraseña?',
    'login.recoverLink': 'Recuperar contraseña',
    'login.notice.otpPendingTitle': 'Falta validar tu OTP para completar el registro.',
    'login.notice.otpPendingBody': 'Serás redirigido en {seconds} segundos para reenviar el código y continuar.',
    'login.notice.sessionExpired': 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    'login.notice.googleError': 'Error al iniciar sesión con Google',
    'login.error.invalidForm': 'Ingresa un correo electrónico y contraseña válidos.',
    'login.error.invalidCredentials': 'Correo electrónico o contraseña inválidos. Intenta nuevamente.',
    'login.error.noConnection': 'No hay conexión con el servidor. Verifica tu red.',
    'login.error.generic': 'No pudimos iniciar sesión. Intenta nuevamente.',
    'login.error.userNotFound': 'No encontramos una cuenta registrada con ese correo.',
    'login.error.otpRequired': 'Tu registro aún está pendiente de validación por OTP.',
    'login.error.otpContractInvalid': 'No pudimos continuar la validación OTP porque la respuesta del servidor está incompleta.',
    'login.error.otpExpired': 'Tu código OTP venció. Debes registrarte nuevamente para continuar.',
    'login.error.otpResendFailed': 'No pudimos reenviar el código OTP. Intenta nuevamente.',
    'login.error.emailRequired': 'Ingresa tu correo electrónico.',
    'login.error.emailInvalid': 'Ingresa un correo electrónico válido.',
    'login.error.emailMax': 'Este campo admite máximo 254 caracteres.',
    'login.error.passwordRequired': 'Ingresa tu contraseña.',
    'login.error.passwordMin': 'Tu contraseña debe tener mínimo 8 caracteres.',
    'login.password.show': 'Mostrar contraseña',
    'login.password.hide': 'Ocultar contraseña',
    'login.footer.developedBy': 'Developed By',
  },
  en: {
    'login.title': 'Log in',
    'login.subtitle': 'Access the platform quickly and securely',
    'login.field.email': 'Email',
    'login.field.password': 'Password',
    'login.cta': 'Log in',
    'login.ctaLoading': 'Signing in...',
    'login.recoverLead': 'Forgot your password?',
    'login.recoverLink': 'Recover password',
    'login.notice.otpPendingTitle': 'OTP verification is still pending to complete your registration.',
    'login.notice.otpPendingBody': 'You will be redirected in {seconds} seconds to resend the code and continue.',
    'login.notice.sessionExpired': 'Your session has expired. Please sign in again.',
    'login.notice.googleError': 'Error signing in with Google',
    'login.error.invalidForm': 'Enter a valid email and password.',
    'login.error.invalidCredentials': 'Invalid email or password. Please try again.',
    'login.error.noConnection': 'There is no connection to the server. Check your network.',
    'login.error.generic': 'We could not sign you in. Please try again.',
    'login.error.userNotFound': 'We could not find an account registered with that email.',
    'login.error.otpRequired': 'Your registration is still pending OTP verification.',
    'login.error.otpContractInvalid': 'We could not continue OTP verification because the server response is incomplete.',
    'login.error.otpExpired': 'Your OTP code expired. You must register again to continue.',
    'login.error.otpResendFailed': 'We could not resend the OTP code. Please try again.',
    'login.error.emailRequired': 'Enter your email.',
    'login.error.emailInvalid': 'Enter a valid email address.',
    'login.error.emailMax': 'This field supports up to 254 characters.',
    'login.error.passwordRequired': 'Enter your password.',
    'login.error.passwordMin': 'Your password must be at least 8 characters long.',
    'login.password.show': 'Show password',
    'login.password.hide': 'Hide password',
    'login.footer.developedBy': 'Developed By',
  },
};
